import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { SyncProgress } from '../core/sync-source';
import { SyncConfig } from '../core/api-config';



@Injectable({
    providedIn: 'root'
})
export class RealtimeService {
    // Realtime sync progress stream
    readonly updates$ = new Subject<SyncProgress>();

    // SignalR connection
    private hub?: signalR.HubConnection;

    /// <summary>
    /// Start the realtime sync progress connection.
    /// </summary>
    async start(): Promise<void> {
        // Avoid opening more than one connection
        if (this.hub) {
            return;
        }

        // Configure hub connection
        this.hub = new signalR.HubConnectionBuilder()
            .withUrl(`${SyncConfig.syncUrl}/hubs/sync`)
            .withAutomaticReconnect()
            .build();

        // Publish received sync progress events
        this.hub.on('syncUpdated', (progress: SyncProgress) => {
            this.updates$.next(progress);
        });

        // Start hub connection
        await this.hub.start();
    }
}
